import { MoveGenerator } from '../../jscaip/AI/AI';
import { GipfProjectHelper } from '../../jscaip/GipfProjectHelper';
import { GipfMove } from './GipfMove';
import { GipfRules } from './GipfRules';
export class GipfMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const moves = [];
        if (GipfRules.isGameOver(state)) {
            return moves;
        }
        this.getPossibleCaptureCombinations(state).forEach((initialCaptures) => {
            const stateAfterCapture = GipfRules.applyCaptures(initialCaptures, state);
            GipfRules.getPlacements(stateAfterCapture).forEach((placement) => {
                const stateAfterPlacement = GipfRules.applyPlacement(placement, stateAfterCapture);
                this.getPossibleCaptureCombinations(stateAfterPlacement)
                    .forEach((finalCaptures) => {
                    const moveSimple = new GipfMove(placement, initialCaptures, finalCaptures);
                    moves.push(moveSimple);
                });
            });
        });
        return moves;
    }
    getPossibleCaptureCombinations(state) {
        const possibleCaptures = GipfRules.getPossibleCaptures(state);
        return GipfProjectHelper.getPossibleCaptureCombinationsFromPossibleCaptures(possibleCaptures);
    }
}
